// extracted by mini-css-extract-plugin
export default {"title":"StyledModalTitle_title__puIX6","subtitle":"StyledModalTitle_subtitle__BRP2q"};